import Loader from "@components/Loader";
import { HOME } from "@constants/routes";
import UserContext from "@context/UserContext";
import avatar_logo from "@images/shared/profile-default.png";
import { useContext } from "react";
import { Redirect } from "react-router-dom";
import { TUserContext } from "types/Core/Authentication/userContext";
import LockScreenForm from "./components/LockScreenForm";

const LockScreen = () => {
  const {
    locked,
    currentUser,
    isLoading,
    errorAuthMessage,
    HandleUnLockScreen,
  } = useContext<TUserContext>(UserContext);

  if (!locked) {
    return <Redirect to={HOME} />;
  }
  return (
    <div className="account">
      <div className="account__wrapper">
        <div className="account__card">
          <div className="account__profile">
            <img
              className="account__avatar"
              src={avatar_logo}
              alt="avatar logo"
            />
            <p className="account__name">{currentUser?.userName}</p>
            <p className="account__sub">Unlock your account</p>
          </div>
          {isLoading ? (
            <Loader isInsideThing />
          ) : (
            <LockScreenForm
              onSubmit={HandleUnLockScreen}
              errorMessage={errorAuthMessage}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default LockScreen;
